var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser)?_c('div',[_c(_vm.homePage,{tag:"component",attrs:{"user":_vm.currentUser}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }